import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddObjectifProfilTypeCreditComponent } from "./add-objectif-profil-type-credit/add-objectif-profil-type-credit.component";
import { EditObjectifProfilTypeCreditComponent } from "./edit-objectif-profil-type-credit/edit-objectif-profil-type-credit.component";
import { UserProfile } from "../core/model/user-profile";
import { Workflow } from "../core/model/workflow";
import { TypeCredit } from "../core/model/type-credit";
import { ObjProfilTypeCred } from "../core/model/obj-profil-type-cred";
import { WorkflowService } from "../core/service/workflow.service";
import { TypeCreditService } from "../core/service/type-credit.service";
import { UserProfileService } from "../core/service/user-profile.service";
import { ObjProfilTypeCredService } from "../core/service/objectif-profil-type-credit.service";

@Component({
  selector: "app-objectif-profil-type-credit",
  templateUrl: "./objectif-profil-type-credit.component.html",
  styleUrls: ["./objectif-profil-type-credit.component.scss"],
})
export class ObjectifProfilTypeCreditComponent implements OnInit {
  userProfiles: UserProfile[];
  workflows: Workflow[];
  typeCredits: TypeCredit[];
  objProfilTypeCreds: ObjProfilTypeCred[];
  userProfile: UserProfile;

  form: FormGroup;

  constructor(
    private _router: Router,
    private spinner: NgxSpinnerService,
    private _workflowService: WorkflowService,
    private _typeCreditService: TypeCreditService,
    private _userProfileService: UserProfileService,
    private _objProfilTypeCredService: ObjProfilTypeCredService,
    private fb: FormBuilder,
    private modalService: NgbModal
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      userProfile: [null, Validators.compose([Validators.required])],
      workflow: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getAllWorkflows();
    this.getUserProfile();
  }

  getAllWorkflows() {
    this._workflowService.getAllWorkflows().subscribe(
      (data) => {
        this.workflows = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUserProfile() {
    this._userProfileService.getUserProfiles().subscribe(
      (data) => {
        this.userProfiles = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getObjProfilTypeCredsByProfilId() {
    this._objProfilTypeCredService
      .getObjProfilTypeCredsByProfilId(
        this.form.value.userProfile.id,
        this.form.value.workflow.id
      )
      .subscribe(
        (data) => {
          this.objProfilTypeCreds = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  refreshTable() {
    this.getDynamicTypeCredityWorkflowIdAndProfilId();
    this.getObjProfilTypeCredsByProfilId();
  }

  getDynamicTypeCredityWorkflowIdAndProfilId() {
    this._typeCreditService
      .getDynamicTypeCredityWorkflowIdAndProfilId(
        this.form.value.userProfile.id,
        this.form.value.workflow.id
      )
      .subscribe(
        (data) => {
          this.typeCredits = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  edit(objProfilTypeCredId): void {
    const modalRef = this.modalService.open(
      EditObjectifProfilTypeCreditComponent,
      { centered: true }
    );
    modalRef.componentInstance.objProfilTypeCredId = objProfilTypeCredId;

    modalRef.result.then(
      (data) => {
        // on close
        this.refreshTable();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  add(typeCreditId): void {
    const modalRef = this.modalService.open(
      AddObjectifProfilTypeCreditComponent,
      { centered: true }
    );
    modalRef.componentInstance.userProfileId = this.form.value.userProfile.id;
    modalRef.componentInstance.typeCreditId = typeCreditId;

    modalRef.result.then(
      (data) => {
        // on close
        this.refreshTable();
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
